import React from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import EmptyScreen from "../../commonComponents/EmptyScreen";
import SignatureFailed from "../../assets/signature-failed-1.png";

// import Iframe from "react-iframe";

class IFrameSignature extends React.PureComponent {
  render() {
    console.debug("IFrameSignature");
    if (this.props.signatureIFrameURL) {
      return (
        <React.Fragment>
          <div className="signature-envelopedetails-wrapper">
            <div className="signature-envelope-card">
              <div className="esign-error-instruction">
                Prepare documents for signature in 3 easy steps
              </div>
            </div>
            <div className="signature-envelope-card">
              <div className="esign-error-instruction">
                <div className="esign-error-number">1</div>
                Select a {"Signer"} name from Recipients
                <i className="esign-error-arrow">
                  <FontAwesomeIcon icon={["far", "arrow-right"]} />
                </i>
              </div>
            </div>
            <div className="signature-envelope-card">
              <div className="esign-error-instruction">
                <div className="esign-error-number">2</div>
                Drag the {"signature"} field and drop it to the desired location
                on the doc.This will serve as the placeholder
                <i className="esign-error-arrow">
                  <FontAwesomeIcon icon={["far", "arrow-right"]} />
                </i>
              </div>
            </div>
            <div className="signature-envelope-card">
              <div className="esign-error-instruction">
                <div className="esign-error-number">3</div>Click {"Share"}
              </div>
            </div>
          </div>
          <iframe
            title="Document Signature Iframe"
            src={`${this.props.signatureIFrameURL}`}
            id="document-signature-iframe"
            className="esign-wrapperpages"
            display="initial"
            position="relative"
            width="100%"
            height="100%"
            allowFullScreen={false}
          />
        </React.Fragment>
      );
    }
    return (
      <EmptyScreen
        imageSrc={SignatureFailed}
        message="Signature request failed, please refresh the page."
      />
    );
  }
}

const mapStateToProps = state => {
  const { signatureIFrameURL } = state.DocumentStore;
  return {
    signatureIFrameURL,
  };
};

export default connect(
  mapStateToProps,
  null,
)(IFrameSignature);



// WEBPACK FOOTER //
// ./src/components/IFrameSignature/IFrameSignature.js